import { BalanceData } from '@/wallets/types/wallet.type'

type AddressPurposeType = 'ordinals' | 'payment' | 'stacks'

type XverseEventType = 'accountChange' | 'networkChange' | 'accountDisconnected'

export const AddressPurpose: { [K in Capitalize<AddressPurposeType>]: Lowercase<K> } = {
  Ordinals: 'ordinals',
  Payment: 'payment',
  Stacks: 'stacks',
} as const

type XverseAddress = {
  address: string
  publicKey: string
  purpose: 'payment' | 'ordinals' | 'stacks'
  addressType: 'p2tr' | 'p2wpkh' | 'p2sh' | 'stacks'
}

export interface AddressResponse {
  address: string
  publicKey: string
  purpose: AddressPurposeType
}

interface GetAddressesResult {
  addresses: AddressResponse[]
}

interface SignMessageResult {
  signature: string
  publicKey: string
}

interface TransferRecipient {
  address: string
  amount: number
}

interface SendTransferResult {
  txid: string
}

interface XverseResponse<T> {
  result: T
  error?: {
    message: string
  }
}

interface SignPsbtParams {
  psbt: string
  signInputs: Record<string, number[]>
  broadcast?: boolean
  allowedSignHash?: number
}

interface SignPsbtResult {
  psbt: string
  txid?: string
}

type XverseRequestParams = {
  getAddresses: {
    purposes: AddressPurposeType[]
    message?: string
  }
  getBalance: undefined
  sendTransfer: {
    recipients: TransferRecipient[]
  }
  signMessage: {
    address: string
    message: string
  }
  wallet_requestPermissions: undefined
  wallet_renouncePermissions: undefined

  signPsbt: SignPsbtParams
  wallet_getAccount: null
}

type XverseRequestResults = {
  getAddresses: GetAddressesResult
  getBalance: BalanceData
  sendTransfer: SendTransferResult
  signMessage: SignMessageResult
  wallet_requestPermissions: unknown
  wallet_renouncePermissions: unknown
  signPsbt: SignPsbtResult
  wallet_getAccount: XverseAddress[]
}

export interface XverseEventData {
  type: XverseEventType
  network?: string
  addresses?: AddressResponse[]
}

export interface XverseBitcoinProvider {
  request<T extends keyof XverseRequestParams>(
    method: T,
    params: XverseRequestParams[T]
  ): Promise<XverseResponse<XverseRequestResults[T]>>

  addListener?(eventName: XverseEventType, callback: (event: XverseEventData) => void): () => void
}

export interface XverseInstance {
  BitcoinProvider: XverseBitcoinProvider
}
